/* Spring Bloom Landingpage (sbl-). Texte stehen im HTML (Weglot), hier nur Zahlen, Zustände und Warenkorb. */
(function () {
  "use strict";
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var SVGNS = "http://www.w3.org/2000/svg";

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function mmss(s) { s = Math.max(0, Math.floor(s)); return Math.floor(s / 60) + ":" + String(s % 60).padStart(2, "0"); }
  function r5(x) { return Math.round(x / 5) * 5; }
  function show(el, on) { if (el) el.hidden = !on; }
  function press(box, attr, val) { $$("[" + attr + "]", box).forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute(attr)) === String(val) ? "true" : "false"); }); }

  function init(root) {
    var sid = root.getAttribute("data-sbl");
    var D;
    try { D = JSON.parse(document.getElementById("sbl-data-" + sid).textContent); } catch (e) { return; }
    var lang = (document.documentElement.lang || "de").slice(0, 2);
    var fmt;
    try { fmt = new Intl.NumberFormat(lang === "de" ? "de-DE" : lang, { style: "currency", currency: D.cur || "EUR" }); }
    catch (e) { fmt = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }); }
    function money(c) { return fmt.format(Math.round(c) / 100); }

    /* ---------- Hero: Sprechblase ---------- */
    function hearts(host, n) {
      if (reduce || !host) return;
      for (var i = 0; i < n; i++) {
        var h = document.createElementNS(SVGNS, "svg");
        h.setAttribute("viewBox", "0 0 24 24"); h.setAttribute("width", "22"); h.setAttribute("height", "22");
        h.setAttribute("class", "sbl-heart"); h.setAttribute("aria-hidden", "true");
        var p = document.createElementNS(SVGNS, "path");
        p.setAttribute("d", "M12 21s-7.5-4.6-9.6-9.3C.9 8.3 3 4.5 6.7 4.5c2.2 0 3.6 1.2 4.3 2.4.7-1.2 2.1-2.4 4.3-2.4 3.7 0 5.8 3.8 4.3 7.2C19.5 16.4 12 21 12 21z");
        p.setAttribute("fill", "#D94C76"); h.appendChild(p);
        h.style.left = (35 + Math.random() * 35) + "%"; h.style.top = (25 + Math.random() * 30) + "%";
        h.style.setProperty("--dx", ((Math.random() - 0.5) * 120) + "px"); h.style.animationDelay = (i * 0.08) + "s";
        host.appendChild(h);
        setTimeout(function (el) { return function () { el.remove(); }; }(h), 2200);
      }
    }
    var speech = $("[data-sbl-speech]", root);
    if (speech) speech.addEventListener("click", function () {
      show($("[data-state=a]", speech), false); show($("[data-state=b]", speech), true);
      hearts(speech.parentNode, 7);
    });

    /* ---------- Steckbrief ---------- */
    var profile = $("[data-sbl-profile]", root), nopes = 0, matched = false;
    function reveal(key) { var m = $('[data-chat="' + key + '"]', root); if (m) { m.hidden = false; } }
    var nopeBtn = $("[data-sbl-nope]", root), likeBtn = $("[data-sbl-like]", root);
    if (nopeBtn) nopeBtn.addEventListener("click", function () {
      profile.classList.remove("sbl-nope"); void profile.offsetWidth; profile.classList.add("sbl-nope");
      nopes++; reveal("nope" + Math.min(nopes, 3));
    });
    if (likeBtn) likeBtn.addEventListener("click", function () {
      hearts(profile, matched ? 5 : 9);
      if (matched) return;
      matched = true; profile.classList.add("sbl-liked"); reveal("match");
      setTimeout(function () { reveal("match2"); }, 500);
      setTimeout(function () { reveal("match3"); }, 1100);
    });

    /* ---------- Rezepte: Daten ---------- */
    var R = {
      v60: { opts: [1, 2], def: 1, unit: "cup", temp: "92–96 °C",
        dose: function (w) { return Math.round(w * 0.06); }, bloom: function (d) { return r5(d * 2.5); },
        times: function (n) { return n === 1 ? [0, 45, 75, 105, 180] : [0, 45, 90, 120, 210]; },
        pours: function (n) { return n === 1 ? [10, 20, 20] : [12, 30, 25]; },
        label: function (n) { return n === 1 ? "2:30–3:30" : "3:00–4:00"; } },
      chemex: { opts: [2, 3, 4], def: 2, unit: "cup", temp: "94 °C",
        dose: function (w) { return Math.round(w * 0.06); }, bloom: function (d) { return r5(d * 2); },
        times: function () { return [0, 45, 90, 150, 270]; }, pours: function () { return [12, 30, 40]; },
        label: function () { return "4:00–5:00"; } },
      press: { opts: [2, 3, 4], def: 2, unit: "cup", temp: "92 °C",
        dose: function (w) { return Math.round(w / 16); }, bloom: function (d, w) { return r5(w / 2); },
        times: function () { return [0, 30, 255, 270, 285]; }, pours: function () { return [15, 15]; },
        label: function () { return "4:30"; } },
      machine: { opts: [0.5, 0.75, 1, 1.25], def: 1, unit: "l", temp: "92–96 °C",
        dose: function (w) { return Math.round(w * 0.055 * 2) / 2; }, bloom: function () { return null; },
        times: function () { return []; }, pours: function () { return []; },
        label: function () { return "4:00–6:00"; } }
    };
    function amounts(m, n) {
      var rc = R[m], water = rc.unit === "l" ? Math.round(n * 1000) : n * 250;
      var dose = rc.dose(water), bloom = rc.bloom(dose, water);
      var p1 = m === "press" ? water : r5(water * 0.6);
      var times = rc.times(n), pours = rc.pours(n);
      var targets = m === "press" ? [bloom, water] : [bloom, p1, water];
      return { water: water, dose: dose, bloom: bloom, p1: p1, times: times, pours: pours, targets: targets, label: rc.label(n) };
    }
    function g(x) { return (Math.round(x * 10) / 10).toLocaleString(lang === "de" ? "de-DE" : lang) + " g"; }

    /* ---------- Mitbrühen (Animation, Handfilter) ---------- */
    var sim = $("[data-sbl-sim]", root);
    if (sim) (function () {
      var svg = $(".sbl-sim-svg", sim);
      var el = function (k) { return $('[data-sim="' + k + '"]', svg); };
      var B = function (k) { return $('[data-b="' + k + '"]', sim); };
      var stream = el("stream"), dome = el("dome"), water = el("water"), jug = el("jug"), bubbles = el("bubbles"),
        drips = el("drips"), flies = el("flies"), flowers = el("flowers"), sT = el("scale-t"), sG = el("scale-g");
      var nowEl = B("now"), initialNow = nowEl.innerHTML, startBtn = B("start");
      var cups = 1, fresh = 1, A = amounts("v60", 1);
      var st = { run: false, t0: 0, acc: 0, speed: 1, raf: 0, last: -1, done: false, lock: null, demo: false, lastBub: 0, lastDrip: 0 };

      function label(k) { $$("[data-l]", startBtn).forEach(function (s) { s.hidden = s.getAttribute("data-l") !== k; }); }
      function steps() { return $$("[data-i]", B("steps")); }
      function fill() {
        A = amounts("v60", cups);
        B("dose").textContent = A.dose; B("water").textContent = A.water;
        $$("[data-v]", B("steps")).forEach(function (s) { s.textContent = A[s.getAttribute("data-v")]; });
        steps().forEach(function (li, i) { $("time", li).textContent = mmss(A.times[i]); });
      }
      function poured(t) {
        var v = 0;
        for (var i = 0; i < A.targets.length; i++) {
          var s = A.times[i], d = A.pours[i], prev = i ? A.targets[i - 1] : 0;
          if (t >= s + d) v = A.targets[i];
          else if (t > s) { v = prev + (A.targets[i] - prev) * (t - s) / d; break; }
          else break;
        }
        return v;
      }
      function pouring(t) {
        for (var i = 0; i < A.targets.length; i++) if (t > A.times[i] && t < A.times[i] + A.pours[i]) return true;
        return false;
      }
      var END = function () { return A.times[A.times.length - 1]; };
      function render(t) {
        var P = poured(t), absorbed = Math.min(P, 2 * A.dose), endT = END();
        var rate = (A.water - 2 * A.dose) / (endT - 45);
        var drained = t < 45 ? 0 : Math.min(Math.max(0, P - absorbed), rate * (t - 45));
        var level = Math.max(0, Math.min(1, (P - absorbed - drained) / (A.water * 0.5)));
        var h = level * 120; water.setAttribute("y", 212 - h); water.setAttribute("height", h);
        var jh = Math.min(1, drained / (A.water * 0.9)) * 64; jug.setAttribute("y", 332 - jh); jug.setAttribute("height", jh);
        stream.classList.toggle("sbl-on", st.run && pouring(t));
        var kt = el("kettle"); if (kt) kt.classList.toggle("sbl-tilt", st.run && pouring(t));
        var inBloom = t > 1 && t < 45;
        dome.style.transform = "scaleY(" + (t <= 0.5 ? 0.04 : inBloom ? (fresh ? 1 : 0.28) : 0.12) + ")";
        flies.setAttribute("opacity", inBloom && fresh ? "1" : "0");
        sT.textContent = mmss(t); sG.textContent = Math.round(P) + " g";
        B("clock").textContent = mmss(t);
        var now = performance.now();
        if (st.run && !reduce && inBloom && now - st.lastBub > (fresh ? 120 : 520)) { st.lastBub = now; bubble(); if (fresh) bubble(); }
        if (st.run && !reduce && t > 46 && drained < A.water - 2 * A.dose - 1 && now - st.lastDrip > 260) { st.lastDrip = now; drip(); }
        // Schritte
        var idx = 0, T = A.times;
        for (var i = 0; i < T.length; i++) if (t >= T[i]) idx = i;
        var lis = steps();
        lis.forEach(function (li, i) { li.classList.toggle("sbl-now", st.run || st.done ? i === idx : false); li.classList.toggle("sbl-past", (st.run || st.done) && i < idx); });
        if (st.run || st.done) {
          if (idx !== st.last) {
            st.last = idx; nowEl.innerHTML = $("span", lis[idx]).innerHTML;
            if (!st.demo && navigator.vibrate && idx > 0) { try { navigator.vibrate(160); } catch (e) {} }
          }
          var nx = idx + 1 < T.length ? T[idx + 1] - t : -1;
          show(B("nextwrap"), nx > 0); if (nx > 0) B("next").textContent = mmss(Math.ceil(nx));
        }
        show($('[data-note="old"]', sim), (st.run || st.done) && !fresh && t > 2 && t < 60);
        show($('[data-note="smell"]', sim), st.run && fresh && t > 12 && t < 42);
        if (t >= endT && st.run) finish();
      }
      function bubble() {
        var x = 104 + Math.random() * 112, dx = (x - 160) / 60, k = fresh ? 1 : 0.28;
        var top = 167 - Math.sqrt(Math.max(0, 1 - dx * dx)) * 34 * k, y = top + Math.random() * (167 - top) * 0.5 + 2;
        var c = document.createElementNS(SVGNS, "circle");
        c.setAttribute("cx", x.toFixed(1)); c.setAttribute("cy", y.toFixed(1)); c.setAttribute("r", "2.4");
        c.setAttribute("fill", Math.random() < 0.5 ? "#C99A66" : "#A87449"); c.setAttribute("class", "sbl-bub");
        bubbles.appendChild(c); setTimeout(function () { c.remove(); }, 1500);
      }
      function drip() {
        var c = document.createElementNS(SVGNS, "circle");
        c.setAttribute("cx", "160"); c.setAttribute("cy", "228"); c.setAttribute("r", "2.6"); c.setAttribute("fill", "#6E3D24");
        c.setAttribute("class", "sbl-drip"); drips.appendChild(c); setTimeout(function () { c.remove(); }, 950);
      }
      function bloomFlowers() {
        if (reduce) return;
        var cols = ["#F3B8CB", "#FFFFFF", "#E98FAE", "#F5D547"], pts = [[40, 348], [62, 330], [270, 334], [292, 350], [24, 300], [298, 300], [48, 262], [276, 258]];
        pts.forEach(function (p, i) {
          var gq = document.createElementNS(SVGNS, "g"); gq.setAttribute("class", "sbl-flower"); gq.style.animationDelay = (i * 0.08) + "s";
          var st0 = document.createElementNS(SVGNS, "path"); st0.setAttribute("d", "M" + p[0] + " " + (p[1] + 14) + " v-12"); st0.setAttribute("stroke", "#5FA54D"); st0.setAttribute("stroke-width", "2.4");
          gq.appendChild(st0);
          for (var a = 0; a < 5; a++) {
            var ang = a * 72 * Math.PI / 180, pc = document.createElementNS(SVGNS, "circle");
            pc.setAttribute("cx", (p[0] + Math.sin(ang) * 4.5).toFixed(1)); pc.setAttribute("cy", (p[1] - Math.cos(ang) * 4.5).toFixed(1));
            pc.setAttribute("r", "4"); pc.setAttribute("fill", cols[i % 4]); gq.appendChild(pc);
          }
          var ce = document.createElementNS(SVGNS, "circle"); ce.setAttribute("cx", p[0]); ce.setAttribute("cy", p[1]); ce.setAttribute("r", "2.6"); ce.setAttribute("fill", "#F5D547");
          gq.appendChild(ce); flowers.appendChild(gq);
        });
      }
      function elapsed() { return (st.acc + (st.run ? (performance.now() - st.t0) : 0)) / 1000 * st.speed; }
      function loop() { render(elapsed()); if (st.run) st.raf = requestAnimationFrame(loop); }
      function lockOn() {
        if (st.demo || !("wakeLock" in navigator)) return;
        navigator.wakeLock.request("screen").then(function (l) { st.lock = l; show($('[data-note="lock"]', sim), true); }).catch(function () {});
      }
      function lockOff() { if (st.lock) { try { st.lock.release(); } catch (e) {} st.lock = null; } show($('[data-note="lock"]', sim), false); }
      function start(demo) {
        if (st.done) reset();
        st.demo = !!demo; st.speed = demo ? 10 : 1; st.run = true; st.t0 = performance.now();
        label("pause"); lockOn(); loop();
      }
      function pause() { st.acc += performance.now() - st.t0; st.run = false; cancelAnimationFrame(st.raf); label("resume"); lockOff(); render(elapsed()); }
      function finish() { st.run = false; st.done = true; cancelAnimationFrame(st.raf); label("again"); lockOff(); stream.classList.remove("sbl-on"); show(B("nextwrap"), false); bloomFlowers(); render(END()); }
      function reset() {
        cancelAnimationFrame(st.raf); lockOff();
        st = { run: false, t0: 0, acc: 0, speed: 1, raf: 0, last: -1, done: false, lock: null, demo: false, lastBub: 0, lastDrip: 0 };
        bubbles.innerHTML = ""; drips.innerHTML = ""; flowers.innerHTML = "";
        nowEl.innerHTML = initialNow; label("start"); show(B("nextwrap"), false);
        steps().forEach(function (li) { li.classList.remove("sbl-now", "sbl-past"); });
        render(0);
      }
      startBtn.addEventListener("click", function () {
        if (st.run) { if (st.demo) { reset(); start(false); } else pause(); return; }
        if (st.done) { reset(); start(false); return; }
        if (st.acc > 0) { st.run = true; st.t0 = performance.now(); label("pause"); lockOn(); loop(); return; }
        start(false);
      });
      B("demo").addEventListener("click", function () { reset(); start(true); });
      B("reset").addEventListener("click", reset);
      $$("[data-cups]", sim).forEach(function (b) {
        b.addEventListener("click", function () { cups = +b.getAttribute("data-cups"); press(sim, "data-cups", cups); fill(); reset(); });
      });
      $$("[data-fresh]", sim).forEach(function (b) {
        b.addEventListener("click", function () { fresh = +b.getAttribute("data-fresh"); press(sim, "data-fresh", fresh); if (!st.run) render(elapsed()); });
      });
      document.addEventListener("visibilitychange", function () { if (!document.hidden && st.run && !st.lock) lockOn(); });
      fill(); render(0);
    })();

    /* ---------- Rezepte ---------- */
    var panel = $('[data-r="panel"]', root);
    if (panel) (function () {
      var cur = { m: "v60", n: 1 }, tm = { run: false, t0: 0, acc: 0, iv: 0, done: false };
      var Q = function (k) { return $('[data-r="' + k + '"]', root); };
      var nowEl = Q("now"), initial = nowEl.innerHTML, startBtn = Q("start");
      function label(k) { $$("[data-l]", startBtn).forEach(function (s) { s.hidden = s.getAttribute("data-l") !== k; }); }
      function list() { return $('.sbl-steps[data-m-only~="' + cur.m + '"]', panel); }
      function render() {
        var rc = R[cur.m], n = cur.n, A = amounts(cur.m, n);
        $$("[data-m-only]", root.querySelector("#sbl-rezepte")).forEach(function (e) { e.hidden = (" " + e.getAttribute("data-m-only") + " ").indexOf(" " + cur.m + " ") < 0; });
        Q("n").textContent = rc.unit === "l" ? n.toLocaleString(lang === "de" ? "de-DE" : lang) : n;
        Q("unit").textContent = rc.unit === "l" ? Q("u-l").textContent : (n === 1 ? Q("u-cup1").textContent : Q("u-cups").textContent);
        show(Q("hint-cup"), rc.unit !== "l"); show(Q("hint-l"), rc.unit === "l");
        Q("minus").disabled = rc.opts.indexOf(n) <= 0; Q("plus").disabled = rc.opts.indexOf(n) >= rc.opts.length - 1;
        Q("dose").textContent = g(A.dose); Q("water").textContent = g(A.water);
        Q("bloom").textContent = A.bloom == null ? "" : g(A.bloom); show(Q("bloom"), A.bloom != null);
        Q("temp").textContent = rc.temp; Q("time").textContent = A.label;
        var L = list();
        if (L && cur.m !== "machine") {
          $$("[data-v]", L).forEach(function (s) { s.textContent = A[s.getAttribute("data-v")]; });
          $$("[data-i]", L).forEach(function (li, i) { $("time", li).textContent = mmss(A.times[i]); });
        }
        show(Q("timer"), cur.m !== "machine");
        reset();
      }
      function reset() {
        clearInterval(tm.iv); tm = { run: false, t0: 0, acc: 0, iv: 0, done: false };
        Q("clock").textContent = "0:00"; Q("scale").textContent = "0 g"; nowEl.innerHTML = initial; label("start");
        var L = list(); if (L) $$("li", L).forEach(function (li) { li.classList.remove("sbl-now", "sbl-past"); });
      }
      function tick() {
        var A = amounts(cur.m, cur.n), t = (tm.acc + (tm.run ? Date.now() - tm.t0 : 0)) / 1000, idx = 0;
        for (var i = 0; i < A.times.length; i++) if (t >= A.times[i]) idx = i;
        Q("clock").textContent = mmss(t);
        var to = 0; for (var j = 0; j <= idx && j < A.targets.length; j++) to = A.targets[j];
        Q("scale").textContent = Math.round(to) + " g";
        var lis = $$("[data-i]", list());
        if (lis[idx]) nowEl.innerHTML = $("span", lis[idx]).innerHTML;
        lis.forEach(function (li, i) { li.classList.toggle("sbl-now", i === idx); li.classList.toggle("sbl-past", i < idx); });
        if (idx === A.times.length - 1) { clearInterval(tm.iv); tm.run = false; tm.done = true; label("again"); }
      }
      startBtn.addEventListener("click", function () {
        if (tm.done) reset();
        if (tm.run) { tm.acc += Date.now() - tm.t0; tm.run = false; clearInterval(tm.iv); label("resume"); return; }
        tm.run = true; tm.t0 = Date.now(); label("pause"); tick(); tm.iv = setInterval(tick, 250);
      });
      Q("reset").addEventListener("click", reset);
      $$(".sbl-tab", root).forEach(function (t) {
        t.addEventListener("click", function () {
          cur.m = t.getAttribute("data-m"); cur.n = R[cur.m].def;
          $$(".sbl-tab", root).forEach(function (x) { x.setAttribute("aria-selected", x === t ? "true" : "false"); });
          panel.setAttribute("aria-labelledby", t.id); render();
        });
      });
      Q("minus").addEventListener("click", function () { var o = R[cur.m].opts, i = o.indexOf(cur.n); if (i > 0) { cur.n = o[i - 1]; render(); } });
      Q("plus").addEventListener("click", function () { var o = R[cur.m].opts, i = o.indexOf(cur.n); if (i < o.length - 1) { cur.n = o[i + 1]; render(); } });
      render();
    })();

    /* ---------- Wie war's? ---------- */
    $$("[data-fix]", root).forEach(function (b) {
      b.addEventListener("click", function () {
        var k = b.getAttribute("data-fix");
        press(root.querySelector(".sbl-fix"), "data-fix", k);
        $$("[data-fix-out]", root).forEach(function (p) { p.hidden = p.getAttribute("data-fix-out") !== k; });
      });
    });

    /* ---------- Abo ---------- */
    var abo = $("[data-sbl-abo]", root);
    if (abo) (function () {
      var S = function (k) { return $('[data-s="' + k + '"]', abo); };
      var boxSize = $('[data-opt="size"]', abo), boxGrind = $('[data-opt="grind"]', abo), boxPlan = $('[data-opt="plan"]', abo);
      var firstSize = $("[data-v]", boxSize), firstGrind = $("[data-v]", boxGrind);
      var planBtn4 = $('[aria-pressed="true"]', boxPlan) || $("[data-v]", boxPlan);
      var A = { plan: "unl", size: firstSize ? firstSize.getAttribute("data-v") : "", grind: firstGrind ? firstGrind.getAttribute("data-v") : "",
        sp: planBtn4 ? +planBtn4.getAttribute("data-v") : 0, qty: 1, cups: 2 };
      var GRAMS = function (o1) { var m = /([\d.]+)\s*(kg|g)/i.exec(o1 || ""); if (!m) return 250; return m[2].toLowerCase() === "kg" ? +m[1] * 1000 : +m[1]; };
      function list(plan) { return (D[plan] && D[plan].v) || []; }
      function find(plan, o1, o2) { var L = list(plan); for (var i = 0; i < L.length; i++) if (L[i].o1 === o1 && L[i].o2 === o2) return L[i]; return null; }
      function single(o1, o2) { for (var i = 0; i < D.main.length; i++) if (D.main[i].o1 === o1 && D.main[i].o2 === o2) return D.main[i]; return null; }
      function chipText(box, val) { var b = $('[data-v="' + (window.CSS && CSS.escape ? CSS.escape(String(val)) : String(val)) + '"]', box); return b ? b.textContent.trim() : ""; }
      function perBag(plan, v) {
        if (!v) return 0;
        if (plan === "unl") return (v.sp && v.sp[A.sp] != null) ? v.sp[A.sp] : v.p;
        return v.p / D[plan].n;
      }
      function shipDE(sub, grams, free) {
        if (free) return 0;
        if (sub >= D.ship.freeFrom) return 0;
        return grams <= D.ship.smallMax ? D.ship.small : D.ship.large;
      }
      // Preise auf den Plankarten (250 g, ganze Bohne)
      ["unl", "m6", "m12"].forEach(function (p) {
        var L = list(p); if (!L.length) return;
        var v = find(p, L[0].o1, L[0].o2) || L[0];
        var el = $('[data-pp="' + p + '"]', abo); if (el) el.textContent = money(perBag(p, v));
      });
      var hm = $("[data-sbl-heromin]", root);
      if (hm && D.m12.v.length) hm.textContent = money(D.m12.v[0].p / D.m12.n);
      (function () {
        var b = single(A.size, A.grind), gr = null;
        for (var i = 0; i < D.main.length; i++) if (D.main[i].o1 === A.size && D.main[i].o2 !== A.grind) { gr = D.main[i]; break; }
        var fee = $("[data-grind-fee]", abo); if (fee && b && gr) fee.textContent = money(gr.p - b.p);
      })();
      S("freefrom") && (S("freefrom").textContent = money(D.ship.freeFrom));

      function render() {
        if (!find(A.plan, A.size, A.grind)) {
          var L = list(A.plan), alt = null;
          for (var i = 0; i < L.length; i++) if (L[i].o1 === A.size) { alt = L[i]; break; }
          if (!alt) { A.size = L.length ? L[0].o1 : A.size; alt = find(A.plan, A.size, A.grind) || L[0]; }
          if (alt) A.grind = alt.o2;
        }
        var v = find(A.plan, A.size, A.grind), sv = single(A.size, A.grind);
        $$(".sbl-plan", abo).forEach(function (b) { b.setAttribute("aria-checked", b.getAttribute("data-plan") === A.plan ? "true" : "false"); });
        press(boxSize, "data-v", A.size); press(boxGrind, "data-v", A.grind); press(boxPlan, "data-v", A.sp);
        $$("[data-v]", boxSize).forEach(function (b) { var s = b.getAttribute("data-v"); b.disabled = !list(A.plan).some(function (x) { return x.o1 === s; }); });
        $$("[data-v]", boxGrind).forEach(function (b) { b.disabled = !find(A.plan, A.size, b.getAttribute("data-v")); });
        var kiloOnly = $$("[data-v]", boxGrind).filter(function (b) { return !b.disabled; }).length <= 1;
        show($('[data-hint="grind"]', abo), !kiloOnly); show($('[data-hint="kilo"]', abo), kiloOnly);
        show($("[data-rhythm]", abo), A.plan === "unl");
        $('[data-q="n"]', abo).textContent = A.qty;
        $('[data-q="minus"]', abo).disabled = A.qty <= 1; $('[data-q="plus"]', abo).disabled = A.qty >= 3;

        var planCard = $('.sbl-plan[data-plan="' + A.plan + '"]', abo);
        S("title").textContent = $(".sbl-p-name", planCard).textContent;
        var rhythm = A.plan === "unl" ? chipText(boxPlan, A.sp) : $(".sbl-p-sub", planCard).textContent.trim();
        S("sub").textContent = (A.qty > 1 ? A.qty + " × " : "") + chipText(boxSize, A.size) + " · " + chipText(boxGrind, A.grind) + " · " + rhythm;
        S("img").src = GRAMS(A.size) >= 1000 ? D.bag1000 : D.bag250;

        var ok = !!(v && v.a);
        show(S("na"), !ok); S("err").hidden = true;
        var add = S("add");
        add.setAttribute("aria-disabled", ok ? "false" : "true");
        if (!v) return;
        var pb = perBag(A.plan, v), perDel = pb * A.qty, grams = GRAMS(A.size) * A.qty, isDE = D.country === "DE";
        var spId = A.plan === "unl" ? A.sp : D[A.plan].plan;
        add.href = (D[A.plan].url || "/") + "?variant=" + v.id + (spId ? "&selling_plan=" + spId : "");
        S("per").textContent = money(perDel);
        S("single").textContent = sv ? money(sv.p * A.qty) : "–";
        var save = sv ? Math.round((1 - pb / sv.p) * 1000) / 10 : 0;
        S("save").textContent = save > 0 ? save.toLocaleString(lang === "de" ? "de-DE" : lang) + " %" : "–";
        var ship = 0, total;
        if (A.plan === "unl") {
          ship = isDE ? shipDE(perDel, grams, D.ship.unlFree) : 0; total = perDel + ship;
        } else {
          var price = v.p * A.qty; ship = isDE ? shipDE(price, grams, D.ship.preFree) : 0; total = price + ship;
        }
        S("ship").textContent = isDE && ship > 0 ? money(ship) : "";
        show(S("ship-free"), isDE && ship === 0); show(S("ship-per"), isDE && ship > 0 && A.plan === "unl"); show(S("ship-checkout"), !isDE);
        show(S("lbl-first"), A.plan === "unl"); show(S("lbl-once"), A.plan !== "unl");
        S("today").textContent = money(total);
        show(S("note-unl"), A.plan === "unl" && !D.ship.unlFree); show(S("note-unl-free"), A.plan === "unl" && D.ship.unlFree); show(S("note-pre"), A.plan !== "unl");
        renderCalc();
      }
      function suggest() {
        var need = A.cups * D.gpc * 7, best = null;
        var sizes = []; list("unl").forEach(function (x) { if (sizes.indexOf(x.o1) < 0) sizes.push(x.o1); });
        var plans = $$("[data-v]", boxPlan).map(function (b) { return { id: +b.getAttribute("data-v"), w: +b.getAttribute("data-weeks") || 0 }; }).filter(function (p) { return p.w > 0; });
        sizes.forEach(function (s) { plans.forEach(function (p) { [1, 2, 3].forEach(function (q) {
          var sup = GRAMS(s) * q / p.w; if (sup < need) return;
          if (!best || sup < best.sup - 0.01 || (Math.abs(sup - best.sup) < 0.01 && q < best.q)) best = { s: s, p: p.id, q: q, sup: sup };
        }); }); });
        return best;
      }
      function renderCalc() {
        $('[data-c="n"]', abo).textContent = A.cups; $('[data-c="gpc"]', abo).textContent = D.gpc;
        $('[data-c="need"]', abo).textContent = A.cups * D.gpc * 7;
        $('[data-c="minus"]', abo).disabled = A.cups <= 1; $('[data-c="plus"]', abo).disabled = A.cups >= 6;
        var s = suggest();
        $('[data-c="sug"]', abo).textContent = s ? (s.q > 1 ? s.q + " × " : "") + chipText(boxSize, s.s) + " · " + chipText(boxPlan, s.p) : "";
      }
      $$(".sbl-plan", abo).forEach(function (b) { b.addEventListener("click", function () { A.plan = b.getAttribute("data-plan"); render(); }); });
      $$("[data-v]", boxSize).forEach(function (b) { b.addEventListener("click", function () { A.size = b.getAttribute("data-v"); render(); }); });
      $$("[data-v]", boxGrind).forEach(function (b) { b.addEventListener("click", function () { if (!b.disabled) { A.grind = b.getAttribute("data-v"); render(); } }); });
      $$("[data-v]", boxPlan).forEach(function (b) { b.addEventListener("click", function () { A.sp = +b.getAttribute("data-v"); render(); }); });
      $('[data-q="minus"]', abo).addEventListener("click", function () { if (A.qty > 1) { A.qty--; render(); } });
      $('[data-q="plus"]', abo).addEventListener("click", function () { if (A.qty < 3) { A.qty++; render(); } });
      $('[data-c="minus"]', abo).addEventListener("click", function () { if (A.cups > 1) { A.cups--; renderCalc(); } });
      $('[data-c="plus"]', abo).addEventListener("click", function () { if (A.cups < 6) { A.cups++; renderCalc(); } });
      $('[data-c="apply"]', abo).addEventListener("click", function () {
        var s = suggest(); if (!s) return; A.plan = "unl"; A.size = s.s; A.sp = s.p; A.qty = s.q;
        if (!find("unl", A.size, A.grind)) { var x = list("unl").filter(function (y) { return y.o1 === A.size; })[0]; if (x) A.grind = x.o2; }
        render();
      });
      S("add").addEventListener("click", function (e) {
        var v = find(A.plan, A.size, A.grind); if (!v || !v.a) { e.preventDefault(); return; }
        if (!window.fetch) return;
        e.preventDefault();
        var spId = A.plan === "unl" ? A.sp : D[A.plan].plan, item = { id: v.id, quantity: A.qty };
        if (spId) item.selling_plan = spId;
        var root0 = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
        fetch(root0 + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ items: [item] }) })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function () { window.location.href = root0 + "cart"; })
          .catch(function () { S("err").hidden = false; });
      });
      render();
    })();

    /* ---------- Abo-Pille ---------- */
    var pill = $("[data-sbl-pill]", root), hero = $(".sbl-hero", root), aboSec = $("#sbl-abo", root), simEl = $("[data-sbl-sim]", root);
    function onScroll() {
      if (!pill || !hero || !aboSec) return;
      var past = hero.getBoundingClientRect().bottom < 0, r = aboSec.getBoundingClientRect();
      var atAbo = r.top < window.innerHeight * 0.8 && r.bottom > 0;
      var sr = simEl ? simEl.getBoundingClientRect() : null, atSim = sr ? (sr.top < window.innerHeight && sr.bottom > 0) : false;
      pill.classList.toggle("sbl-hide", !past || atAbo || atSim);
    }
    window.addEventListener("scroll", onScroll, { passive: true }); onScroll();

    /* ---------- Bienen & Schmetterlinge: nur animieren, wenn sichtbar ---------- */
    var stages = $$("[data-sbl-crit]", root);
    if (stages.length && "IntersectionObserver" in window) {
      var cio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.target.classList.toggle("sbl-crit-off", !e.isIntersecting); });
      });
      stages.forEach(function (s) { cio.observe(s); });
    }
  }

  function boot() { $$("[data-sbl]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
